import './style.css'
// import * as THREE from 'three'
import { RoundedBoxBufferGeometry } from './rbbg.js'
import { ABRandom, genTokenData } from './ab-random.js'
// console.log(process.env.NODE_ENV);

// random functions
const tokenData = genTokenData(242);
// tokenData.hash = '0x8013d43839634bf05a82f8c258f27bd47aa3ffbe133394fb6a48cac355647ec0';
console.log(tokenData.hash);
const R = new ABRandom(tokenData);

const randomUnitVector = (zmin = -1) => {
    // z form -1 to 1
    const z = R.random_num(zmin, 1);
    const a = R.random_dec() * 2 * Math.PI;
    const l = Math.sqrt(1 - z ** 2);
    const x = l * Math.cos(a);
    const y = l * Math.sin(a);
    return new THREE.Vector3(x, y, z);
}

const randomDirection = (flagShipMatIndex) => {
    // solid, limit direction to front only
    // framed, full range
    return flagShipMatIndex == 0 ? randomUnitVector(0) : randomUnitVector();
}

// feature storage
window.$genFeatures = {}
const setFeature = (name, value) => {
    window.$genFeatures[name] = value;
}
const getFeature = (name) => {
    return window.$genFeatures[name];
}

const COLOR_PALETTES = [
    {
        name: 'soapbar',
        colors: ['#ff0000', '#0000ff'],
        bgColors: ['#ffffff'],
        spot: ['#00fffc'],
    },
    {
        name: 'primary drain',
        colors: ['#ff006e', '#3a86ff', '#ffbe0b', '#003049'],
        bgColors: ['#738290'],
        spot: ['#00fffc'],
    },
    {
        name: 'pasteleria',
        colors: ['#70d6ff', '#ff70a6', '#d9ed92'],
        bgColors: ['#BAD0E6', '#ffffff'],   /// '#C0FFB6']//,  // not green... grey, i dunno
        spot: ['#00fffc'],
    },
    // {
    //     name: 'hard lit',
    //     colors: ['#44ff00', '#9900ff', '#4a5247'],
    //     bgColors: ['#d4baba'],
    //     spot: ['#ffffff']
    // },
    {
        name: 'sliver',
        colors: ['#c4c4c4', '#636363'],
        bgColors: ['#afc6e4', '#b2cedc'],  //'#d4baba',
        spot: ['#00aaff']
    }

]
const boxRadius = 0.03;

const SIZE_PALETTE = {
    's': { ranges: [[0.1, 0.2], [0.1, 0.2], [0.1, 0.2]] },
    'm': { ranges: [[0.2, 0.5], [1, 2], [0.1, 0.5]] },
    'l': { ranges: [[1, 3.5], [4, 6], [0.5, 2.5]] },
}

const CAMERA_PALETTE = [
    {
        name: 'frontal',
        position: [0, 0, 8]  // [-0.2, -0.2, 7.6]
    },
    {
        name: 'low right',
        position: [1.36, -0.67, 7.85]
    },
    {
        name: 'under left',
        position: [-1.41, -1.76, 7.67]
    },
    {
        name: 'close left',
        position: [-1.41, -1.76, 4]
    },
    {
        name: 'close top',
        position: [2.41, -0.76, 6.2]
    },
    {
        name: 'top center right',
        position: [0.7, 3.53, 10.2]
    },
]


const MATERIAL_NAMES = ['solid', 'hollow'];
const MATERIALS = [];

MATERIALS.push(
    // basic soap
    new THREE.MeshStandardMaterial({
        roughness: 0.4,
    }));

const panelMaterial = new THREE.MeshStandardMaterial({
    roughness: 0.4,
    side: THREE.DoubleSide,
});

MATERIALS.push(
    // Array of faces
    [panelMaterial, panelMaterial, panelMaterial, panelMaterial, null, null]
);

// Randomize Features
const palette = R.random_choice(COLOR_PALETTES);
console.log(`palette: ${palette.name}`);

const ANGLE_REGIMES = ['piet', 'von', 'vich'];
const angleRegime = R.random_choice(ANGLE_REGIMES);
setFeature('angle regime', angleRegime);
console.log(`angle regime: ${angleRegime}`);
const rotationRatio = R.random_dec();
let rotationInfluence = 'unknown';
if (angleRegime == 'vich') {
    rotationInfluence = 'irrelevant';
}
else {
    if (rotationRatio < 0.25) {
        rotationInfluence = 'minimal';
    } else if (rotationRatio < 0.75) {
        rotationInfluence = 'moderate';
    } else {
        rotationInfluence = 'total';
    }
}
setFeature('rotationInfluence', rotationInfluence);
console.log(`rotation influence: ${rotationInfluence}`);

const shipCount = R.random_choice([9, 13, 17, 22, 25, 33, 37]);
console.log(`shipCount: ${shipCount}`);
setFeature('shipCount', shipCount);

const flagShipMatIndex = R.random_choice([0, 1]);
const flagShipName = MATERIAL_NAMES[flagShipMatIndex];
console.log(`flagShip: ${flagShipName}`);
const flagShipMaterial = MATERIALS[flagShipMatIndex];

// 14% of ship are rotated
const rotateFlagShip = R.random_bool(0.14);
console.log(`attempt flagShip rotation: ${rotateFlagShip}`);

const drawBackplane = R.random_bool(0.92);
console.log(`paper: ${drawBackplane}`);

const ORGS = ['gang', 'mob', 'anarchopanda'];
const org = R.random_choice(ORGS);
console.log(`organisation: ${org}`);
// anarcho
let directions = null;
let angleSpread = Math.PI * 2;
if ('gang' == org) {
    directions = [0, 1, 2].map(i => randomDirection(flagShipMatIndex));
    angleSpread = Math.PI / 12; // 15 deg
}
else if ('mob' == org) {
    directions = [0, 1, 2, 3, 4].map(i => randomDirection(flagShipMatIndex));
    angleSpread = Math.PI / 6; // 30 deg
}


// Canvas, scene
const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene()
// LIGHTS
const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
scene.add(ambientLight);

// Light at the bottom and light at the top (cheap performace wise)
const topColor = R.random_choice(palette.colors);
const bottomColor = R.random_choice(palette.colors);
//console.log(`top: ${topColor}  bottom: ${bottomColor}`);
let lighting = 'duochrome'
if (topColor == bottomColor) {
    lighting = 'monochromish';
}
setFeature('lighting', lighting);
console.log(`lighting: ${lighting}`);
const hemisphereLight = new THREE.HemisphereLight(topColor, bottomColor, 0.3);
// const hemisphereLight = new THREE.HemisphereLight(0xff0000, 0x0000ff, 0.3)
scene.add(hemisphereLight);

// MEDIUM COST
// light comes from a diredtion (a plane kinda)
// illumanate the center of the scene
const spotColor = R.random_choice(palette.spot);
const directionalLight = new THREE.DirectionalLight(spotColor, 0.3); //'#' '#ff9500'  '#ff0000'  '#ff007b'
directionalLight.position.set(1, 0.25, 2);
scene.add(directionalLight)
// gui.add(directionalLight.position, 'y').min(-5).max(5).step(0.1).name('directional y');
// gui.add(directionalLight, 'intensity').min(0).max(1).step(0.01).name('directional');

// Sunlight - light come from a single point
const pointLight = new THREE.PointLight('#ffA733', 0.5, 10, 2)
pointLight.position.set(0.5, 1.75, 2)
scene.add(pointLight)
// gui.add(pointLight.position, 'y', -3, 5, 0.1);
// gui.add(pointLight, 'intensity').min(0).max(10).step(0.1).name('point');

// const pointLightFront = new THREE.PointLight('#ffA733', 0.3, 10, 2)
// pointLightFront.position.set(-4.5, -2, 0.1)
// scene.add(pointLightFront);
// gui.add(pointLightFront, 'intensity').min(0).max(2).step(0.01).name('point front');

// EXPENSIVE (PREFORMANCE-WISE)
// ReactArea only workson standard material
const rectAreaLight = new THREE.RectAreaLight('#CC4BC2', 2, 1, 1);  //'#4c00ff'
rectAreaLight.position.set(-1.5, 0, 1.5)
rectAreaLight.lookAt(new THREE.Vector3())
scene.add(rectAreaLight)
// gui.add(rectAreaLight, 'intensity').min(0).max(2).step(0.01).name('rect');
// const hlh = new THREE.HemisphereLightHelper(hemisphereLight, 0.2)
// scene.add(hlh)
// const dlh = new THREE.DirectionalLightHelper(directionalLight, 0.2)
// scene.add(dlh)
// const plh = new THREE.PointLightHelper(pointLight, 0.2)
// scene.add(plh)
// const plfh = new THREE.PointLightHelper(pointLightFront, 0.2)
// scene.add(plfh)


// Zupermat
const shipGroup = new THREE.Group();
const createShipGeometry = (size) => {
    const xyzRanges = SIZE_PALETTE[size];
    const xyz = xyzRanges.ranges.map(r => R.random_num(...r));
    const roundedBox = new RoundedBoxBufferGeometry(...xyz, 16, boxRadius);
    return roundedBox;
}

const compositionTiltZ = -Math.PI * R.random_num(-0.04, 0.03);
const compositionTiltX = -Math.PI * R.random_num(-0.02, 0.03);

const createShip = (size, matOverride = null) => {
    const shipGeometry = createShipGeometry(size);
    const shipMaterial = matOverride ? matOverride : R.random_choice(MATERIALS);
    const shipMesh = new THREE.Mesh(
        shipGeometry,
        shipMaterial,
    )
    shipMesh.transparent = true;
    shipMesh.position.z = 3
    shipMesh.rotateZ(compositionTiltZ);
    shipMesh.rotateX(compositionTiltX);
    return shipMesh;
}

const intersectsAnyOtherShips = (ship, otherShips) => {
    var shipBox = new THREE.Box3().setFromObject(ship, true);
    for (let otherShip of otherShips) {
        // console.log(`checking against`, otherShip);
        var otherShipBox = new THREE.Box3().setFromObject(otherShip, true);
        if (shipBox.intersectsBox(otherShipBox)) {
            return true;
        }
    }
    return false;
}

const dispertionRange = [0.15, 0.4];

const chooseDirection = () => {
    let dir = null;
    // console.log(directions)
    if (directions) {
        dir = R.random_choice(directions);
        // TODO add some randomness to the direction based on angleSpread
        const angleVariation = new THREE.Euler(R.random_num(-angleSpread, angleSpread), R.random_num(-angleSpread, angleSpread), R.random_num(-angleSpread, angleSpread))
        dir.applyEuler(angleVariation);
    }
    else {
        dir = randomDirection(flagShipMatIndex);
    }
    return dir;
}

const positionShip = (ship, shipGroup) => {
    // choose random direction
    const direction = chooseDirection();
    // iterate with a random distance until we clear all other ships
    while (intersectsAnyOtherShips(ship, shipGroup.children)) {
        // move ship in choosen direction
        const distance = R.random_num(...dispertionRange);
        ship.position.addScaledVector(direction, distance);
    }
    // console.log(`z: ${ship.position.z}`);
}

// ratation mode? random 0-90, 45 deg
const rotateShip = (ship) => {
    const doRotate = R.random_bool(rotationRatio);
    let angle = 0;
    if ('piet' == angleRegime && doRotate) {
        angle = Math.PI * 0.5;
    }
    else if ('von' == angleRegime) {
        angle = Math.PI * 0.25;
        if (doRotate) {
            angle = -angle;
        }
    }
    else if ('vich' == angleRegime) {
        angle = R.random_num(0, Math.PI);
    }
    ship.rotateZ(angle);
}

// flag ship
const flagShip = createShip('l', flagShipMaterial);

// A rotated flagship is rare
if (rotateFlagShip) {
    rotateShip(flagShip);
}
// slight tilt forward about 6 deg - why not
flagShip.rotateX(0.1);
shipGroup.add(flagShip);
// shart at 1, flasgship done
for (let i = 1; i < shipCount; i++) {
    const size = R.random_choice(['m', 's']);
    // const size = 's'
    const ship = createShip(size);
    positionShip(ship, shipGroup);
    rotateShip(ship);
    if (ship.position.z < 6.2) {
        shipGroup.add(ship);
    }
    else {
        console.log('ship too close, not adding to scene');
    }
}

// 
scene.add(shipGroup);

if (drawBackplane) {
    // background
    const bgColor = R.random_choice(palette.bgColors);
    const backgroundMaterial = new THREE.MeshStandardMaterial({
        color: bgColor,
        roughness: 0.6,
        // wireframe: true 
    });
    const plane = new THREE.Mesh(
        new THREE.PlaneGeometry(8, 8),
        backgroundMaterial
    )
    scene.add(plane)
}

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
const initialCameraCoordinates = R.random_choice(CAMERA_PALETTE);
// console.log(initialCameraCoordinates);
camera.position.set(...initialCameraCoordinates.position);
camera.lookAt(flagShip.position);
scene.add(camera)
// gui.add(camera, 'fov').min(25).max(120).step(1)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    antialias: true,
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


// DEBUG - // axes Helper
// const axesHelper = new THREE.AxesHelper();
// scene.add(axesHelper);

const camCoord1 = R.random_choice(CAMERA_PALETTE.slice(1));
const cameraPosition1 = new THREE.Vector3(...camCoord1.position); //new Vector3(0, 0, 0)
const finalCameraCoordinates = R.random_choice(CAMERA_PALETTE).position;
// const cameraPosition2 = new THREE.Vector3(...finalCameraCoordinates);
const cameraPosition2 = new THREE.Vector3(...CAMERA_PALETTE[0].position);


/**
 * Animate
 */
const clock = new THREE.Clock();

// window.addEventListener('click', () => {
//     console.log('restart');
//     clock.start()
// });

const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    // animation last PI seconds
    if (elapsedTime < Math.PI / 2 * 2) {
        camera.position.lerpVectors(cameraPosition1, cameraPosition2, Math.sin(elapsedTime / 2));
        camera.lookAt(flagShip.position);
    }
    // Update controls
    // controls.update();
    // camera for fov debug
    // camera.updateProjectionMatrix();
    // Render
    renderer.render(scene, camera);
    // Call tick again on the next frame
    window.requestAnimationFrame(tick);
}

tick()